import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
  apiKeys: [],
  totalApiKeys: 0,
  currentPage: 1,
  totalPages: 1,
  selectedApiKey: null,
  selectedApiKeyUsage: [],
  filters: {
    search: "",
    status: "",
    page: 1,
    limit: 10,
  },
  loading: false,
  isError: false,
  errorMessage: "",
};

const adminApiKeysManagementSlice = createSlice({
  name: "ADMIN_API_KEYS_MANAGEMENT",
  initialState: initial_state,
  reducers: {
    updateAdminApiKeysManagement: (state, { payload }) => {
      return { ...state, ...payload };
    },
    setApiKeys: (state, { payload }) => {
      state.apiKeys = payload.apiKeys || payload.data || payload;
      state.totalApiKeys = payload.totalApiKeys || payload.total || (payload.apiKeys ? payload.apiKeys.length : 0);
      state.totalPages = payload.totalPages || Math.ceil((payload.totalApiKeys || payload.total || 0) / 10);
      state.currentPage = payload.currentPage || 1;
    },
    setSelectedApiKey: (state, { payload }) => {
      state.selectedApiKey = payload;
    },
    setSelectedApiKeyUsage: (state, { payload }) => {
      state.selectedApiKeyUsage = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.isError = true;
      state.errorMessage = payload;
    },
    clearError: (state) => {
      state.isError = false;
      state.errorMessage = "";
    },
    setFilters: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
    },
    updateApiKey: (state, { payload }) => {
      const index = state.apiKeys.findIndex((apiKey) => apiKey.id === payload.id);
      if (index !== -1) {
        state.apiKeys[index] = { ...state.apiKeys[index], ...payload };
      }
    },
    deleteApiKey: (state, { payload }) => {
      state.apiKeys = state.apiKeys.filter((apiKey) => apiKey.id !== payload);
      state.totalApiKeys -= 1;
    },
  },
});

export const {
  updateAdminApiKeysManagement,
  setApiKeys,
  setSelectedApiKey,
  setSelectedApiKeyUsage,
  setLoading,
  setError,
  clearError,
  setFilters,
  updateApiKey,
  deleteApiKey,
} = adminApiKeysManagementSlice.actions;
export default adminApiKeysManagementSlice.reducer;
